export default __webpack_public_path__ + "static/media/marker-pinpoint.d51e8d0e.svg";